/**
 * UC-12: ApprovePolicy
 * TOGAF Application ABB — approve an under-review policy without UI deps.
 */
import type { Policy } from '../../../types/policy';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { IPolicyManager } from '../../domain/ports/IPolicyManager';

export interface ApprovePolicyInput {
  policyId: string;
  approver?: string;
}

export interface ApprovePolicyOutput {
  ok: boolean;
  policy?: Policy;
  error?: string;
}

export interface ApprovePolicyDependencies {
  policyManager: IPolicyManager;
  logger?: IAppLogger;
}

export class ApprovePolicyUseCase {
  constructor(private readonly deps: ApprovePolicyDependencies) {}

  execute(input: ApprovePolicyInput): ApprovePolicyOutput {
    const approver = input.approver ?? 'Player';

    try {
      const policy = this.deps.policyManager.approvePolicy(input.policyId, approver);

      this.deps.logger?.log('debug', 'policy.approved', {
        policyId: policy.id,
        approver,
        name: policy.name,
      });

      return { ok: true, policy };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      this.deps.logger?.log('warn', 'policy.approve_failed', {
        policyId: input.policyId,
        error: message,
      });
      return { ok: false, error: message };
    }
  }
}